import React from 'react';

const RouteContext = React.createContext({
  currentRoute: null,
  groups: [],
  defineRoute: () => {},
});

export default RouteContext;
